import { User } from './auth/user';

export const entityMap = {
	// AUTH
	User
};

export { User } from './auth/user';
